import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createUser } from "../Redux/Actions/Useraction";
import notify from "../Hook/useNotification";
import { useTranslation } from "react-i18next";

const CreateAdminModal = ({ show, handleClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "admin", // default
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.password
    ) {
      notify(t("createUser.notify.fill_all"), "error");
      return;
    }

    // ← مش FormData، بعت object عادي
    const body = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      password: formData.password,
      role: formData.role,
    };

    setLoading(true);
    await dispatch(createUser(body));
    setLoading(false);
  };

  const res = useSelector((state) => state.alluser.createuser);
  console.log("create user response", res);

  useEffect(() => {
    if (loading === false) {
      if (res?.data?.status === "success") {
        notify(t("createUser.notify.success"), "success");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          role: "admin",
        });
        setTimeout(() => {
          handleClose();
          window.location.reload(false);
        }, 1000);
      } else {
        notify(t("createUser.notify.error"), "error");
      }
      setLoading(true);
    }
  }, [loading, res?.data?.status, t, handleClose]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("createUser.modal.title")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>{t("createUser.form.firstName")}</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder={t("createUser.form.firstName_placeholder")}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("createUser.form.lastName")}</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder={t("createUser.form.lastName_placeholder")}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("createUser.form.email")}</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t("createUser.form.email_placeholder")}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("createUser.form.password")}</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder={t("createUser.form.password_placeholder")}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t("createUser.form.role")}</Form.Label>
            <Form.Select
              name="role"
              value={formData.role}
              onChange={handleChange}
            >
              <option value="admin">Admin</option>
              <option value="doctor">Doctor</option>
              <option value="optician">Optician</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t("createUser.modal.cancel")}
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {t("createUser.modal.create")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateAdminModal;
